export default "__VITE_ASSET__DhXfU5vk__"